var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "route-login" },
    [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "content-holder" }, [
          _vm._m(0),
          _c("h1", [_vm._v("Inloggen")]),
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.login.apply(null, arguments)
                },
              },
            },
            [
              _c("cms-input", {
                attrs: {
                  type: "text",
                  name: "username",
                  placeholder: "Gebruikersnaam",
                },
                model: {
                  value: _vm.username,
                  callback: function ($$v) {
                    _vm.username = $$v
                  },
                  expression: "username",
                },
              }),
              _c("cms-input", {
                attrs: { type: "password", placeholder: "Wachtwoord" },
                model: {
                  value: _vm.password,
                  callback: function ($$v) {
                    _vm.password = $$v
                  },
                  expression: "password",
                },
              }),
              _c(
                "cms-button",
                { attrs: { loading: _vm.loading }, on: { click: _vm.login } },
                [_vm._v("Inloggen")]
              ),
              _c("input", {
                staticStyle: { display: "none" },
                attrs: { type: "submit" },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "nav-link" },
            [
              _c("router-link", { attrs: { to: { name: "forgot" } } }, [
                _vm._v("Wachtwoord vergeten"),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _c("toast-container"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "logos-holder" }, [
      _c("div", { staticClass: "logo" }, [
        _c("i", { staticClass: "img logo-aveco-color-180" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }